"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cAbuseReportedSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../../hooks");
exports.cAbuseReportedSchema = zod_1.z.strictObject({
    event: zod_1.z.literal(hooks_1.HookName.abuseReported),
    action: zod_1.z.literal(hooks_1.HookName.abuseReported),
    meta: zod_1.z.optional(zod_1.z.strictObject({
        requester: zod_1.z.number()
    })),
    qaUrl: zod_1.z.optional(zod_1.z.string()),
    reportAbuseId: zod_1.z.number(),
    accountId: zod_1.z.number(),
    reportAbuseType: zod_1.z.number(),
    reportAbuseCategory: zod_1.z.string()
});
